export const MENTION_SLIDE_END_TIME_IN_SECONDS = 3;
const MENTION_SLIDE_TRANSITION_DURATION_IN_SECONDS = 0.5;

const mentionSlideDisplayTimeInS = 0.1;
const mentionSlideHideTimeInS =
  MENTION_SLIDE_END_TIME_IN_SECONDS - MENTION_SLIDE_TRANSITION_DURATION_IN_SECONDS;

export const shouldDisplayMentionSlide = (currentTimeInSeconds: number): boolean => {
  return (
    currentTimeInSeconds < mentionSlideHideTimeInS &&
    currentTimeInSeconds > mentionSlideDisplayTimeInS
  );
};

export const getWritersLabel = (writersNames: string[]): string =>
  writersNames.length > 0 ? `(${writersNames.join(' - ')})` : '';

export const getPublishersLabel = (publishersNames: string[]): string =>
  publishersNames.join(' / ');
